var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 70,
    fill: "#f8f0fc",
    stroke: "#a259c6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 30V120",
    stroke: "#a259c6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 50L105 50",
    stroke: "#a259c6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80L100 80",
    stroke: "#a259c6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 110L90 110",
    stroke: "#a259c6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 30,
    r: 8,
    fill: "#f72585"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 80,
    r: 8,
    fill: "#f72585"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 50,
    r: 8,
    fill: "#f72585"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 50,
    r: 8,
    fill: "#f72585"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 110,
    r: 8,
    fill: "#f72585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitations);
export default __webpack_public_path__ + "static/media/limitations.db192448d3f1305ed0a9363e22d2c74e.svg";
export { ForwardRef as ReactComponent };